import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axios";

export const fetchVendorNotifications = createAsyncThunk(
  "vendorNotification/fetchAll",
  async ({ page = 1, limit = 10, search = "" }, thunkAPI) => {
    try {
      const res = await api.get(`/api/vendorNotification?page=${page}&limit=${limit}&search=${search}`);
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed to fetch vendor notifications");
    }
  }
);

export const createVendorNotification = createAsyncThunk(
  "vendorNotification/create",
  async (data, thunkAPI) => {
    try {
      const res = await api.post("/api/vendorNotification", data);
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data?.message || "Failed to create");
    }
  }
);

export const updateVendorNotification = createAsyncThunk(
  "vendorNotification/update",
  async ({ id, data }, thunkAPI) => {
    try {
      const res = await api.put(`/api/vendorNotification/${id}`, data);
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data?.message || "Failed to update");
    }
  }
);

export const toggleVendorNotificationStatus = createAsyncThunk(
  "vendorNotification/toggleStatus",
  async (id, thunkAPI) => {
    try {
      const res = await api.patch(`/api/vendorNotification/${id}/status`);
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed to update status");
    }
  }
);

export const deleteVendorNotification = createAsyncThunk(
  "vendorNotification/delete",
  async (id, thunkAPI) => {
    try {
      await api.delete(`/api/vendorNotification/${id}`);
      return id;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data?.message || "Delete failed");
    }
  }
);

const vendorNotificationSlice = createSlice({
  name: "vendorNotification",
  initialState: {
    notifications: [],
    loading: false,
    error: null,
    pagination: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchVendorNotifications.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchVendorNotifications.fulfilled, (state, action) => {
        state.loading = false;
        state.notifications = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchVendorNotifications.rejected, (state, action) => { state.loading = false; state.error = action.payload; })

      .addCase(createVendorNotification.fulfilled, (state) => {
        state.pagination.total = (state.pagination.total || 0) + 1;
      })
      .addCase(createVendorNotification.rejected, (state, action) => { state.error = action.payload; })

      .addCase(updateVendorNotification.fulfilled, (state, action) => {
        const index = state.notifications.findIndex((n) => n._id === action.payload._id);
        if (index !== -1) state.notifications[index] = action.payload;
      })
      .addCase(updateVendorNotification.rejected, (state, action) => { state.error = action.payload; })

      .addCase(toggleVendorNotificationStatus.fulfilled, (state, action) => {
        const index = state.notifications.findIndex((n) => n._id === action.payload._id);
        if (index !== -1) state.notifications[index] = action.payload;
      })

      .addCase(deleteVendorNotification.fulfilled, (state) => {
        state.pagination.total = (state.pagination.total || 1) - 1;
      })
      .addCase(deleteVendorNotification.rejected, (state, action) => { state.error = action.payload; });
  },
});

export default vendorNotificationSlice.reducer;